import React from 'react'

interface TeamProps {
  isSelected?: boolean
}

export const TeamIcon: React.FC<TeamProps> = ({ isSelected = false }) => {
  const stroke = isSelected ? '#FF4A8E' : '#62718D'
  const className = isSelected ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'

  return (
    <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2628_20999)">
        <path
          d="M4.16602 6.33333C4.16602 7.21739 4.5172 8.06523 5.14233 8.69036C5.76745 9.31548 6.61529 9.66667 7.49935 9.66667C8.3834 9.66667 9.23125 9.31548 9.85637 8.69036C10.4815 8.06523 10.8327 7.21739 10.8327 6.33333C10.8327 5.44928 10.4815 4.60143 9.85637 3.97631C9.23125 3.35119 8.3834 3 7.49935 3C6.61529 3 5.76745 3.35119 5.14233 3.97631C4.5172 4.60143 4.16602 5.44928 4.16602 6.33333Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
        />
        <path
          d="M2.5 18V16.3333C2.5 15.4493 2.85119 14.6014 3.47631 13.9763C4.10143 13.3512 4.94928 13 5.83333 13H9.16667C10.0507 13 10.8986 13.3512 11.5237 13.9763C12.1488 14.6014 12.5 15.4493 12.5 16.3333V18"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
        />
        <path
          d="M13.334 3.10742C14.051 3.29101 14.6865 3.70801 15.1403 4.29268C15.5942 4.87736 15.8405 5.59645 15.8405 6.33659C15.8405 7.07673 15.5942 7.79582 15.1403 8.3805C14.6865 8.96517 14.051 9.38217 13.334 9.56576"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
        />
        <path
          d="M17.5 18V16.3333C17.4958 15.5976 17.2483 14.884 16.7961 14.3037C16.3439 13.7233 15.7124 13.3089 15 13.125"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
        />
      </g>
      <defs>
        <clipPath id="clip0_2628_20999">
          <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default TeamIcon
